import { useEffect, useState } from "react";
import _ from "lodash";

import { getAvatarUrl } from "src/Common/common";
import { getMinutesFromFormattedHours, getFormattedHoursFromMins } from "src/Common/function";

const TotalTechItem = ({
  tech,
}) => {


  return (
    tech &&
    <div className="w-full h-[40px] flex items-center px-3 border-t-[1px] border-borderColor relative">
      <img src={getAvatarUrl(tech.user.avatar)} className="w-[24px] rounded-[12px]" />
      <p className="font-OpenSansRegular text-[14px] font-[400] text-titleColor ml-2 flex-1 min-w-0 truncate mr-[calc(5%+325px)]">
        {tech.user.name}
      </p>

      <div className="absolute right-[5%] top-[3px] h-[34px] flex items-center gap-3">
        <p className="font-OpenSansRegular text-[14px] font-[400] text-titleColor w-[96px] text-center">
          {tech?.regularTime && tech?.regularTime !== "00:00" ? tech?.regularTime : "__:__"}
        </p>
        <p className="font-OpenSansRegular text-[14px] font-[400] text-titleColor w-[96px] text-center">
          {tech?.travelTime && tech?.travelTime !== "00:00" ? tech?.travelTime : "__:__"}
        </p>
        <p className="font-OpenSansRegular text-[14px] font-[400] text-titleColor w-[96px] text-center">
          {tech?.overTime && tech?.overTime !== "00:00" ? tech?.overTime : "__:__"}
        </p>
      </div>


    </div>
  );
};

export default TotalTechItem;

